import React from "react";
import {scaledValue} from "../../../../performance/CompactPerformanceValue";
import styled from "styled-components";
import {Cell} from "./Cell";

export const investmentWidth = 70;

const Container = styled(Cell)`
    flex-basis: ${investmentWidth}px;
    justify-content: flex-end;
    margin-right: 12px;
`;

export const InvestmentCell = ({portfolioIdea}) => {
    const value = portfolioIdea && portfolioIdea.investmentAmount ? `${scaledValue(portfolioIdea.investmentAmount)} ${portfolioIdea.investmentCurrency}` : "\u2014";
    return <Container className="t-current-investment">
        {value}
    </Container>;
};

const Header = styled(Container)`
    margin-right: 0px;
    font-size: 11px;
    font-weight: bold;
`;

export const InvestmentHeader = () => {
    return <Header>
        <div>Investment</div>
    </Header>;
};